import { useMemo } from 'react'

import { useAuth } from '../useAuth/useAuth'

import { getPartnerFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

export const useSpotlightedOrgs = () => {
  const { state } = useAuth()
  const partner = getPartnerFromAuthState(state)

  const spotlightedOrgIds = useMemo(() => {
    return partner?.spotlightedOrgs?.organisationIds || []
  }, [partner])

  const partnerLogo = partner?.spotlightedOrgs?.partnerLogo
  const partnerName = partner?.name

  const isOrgSpotlighted = (organisationId: string) => {
    return spotlightedOrgIds.includes(organisationId)
  }

  return {
    spotlightedOrgIds,
    isOrgSpotlighted,
    partnerLogo,
    partnerName
  }
}
